import { render, staticRenderFns } from "./RatesPackages.vue?vue&type=template&id=00788ebe&scoped=true&"
import script from "./RatesPackages.vue?vue&type=script&lang=js&"
export * from "./RatesPackages.vue?vue&type=script&lang=js&"
import style0 from "./RatesPackages.vue?vue&type=style&index=0&id=00788ebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00788ebe",
  null
  
)

export default component.exports